import { useRegisterSW } from "virtual:pwa-register/react";
import styled from "styled-components";
import { colors } from "../../styles/colors";

const Toast = styled.div`
  position: fixed;
  bottom: 100px;
  left: 50%;
  transform: translateX(-50%);
  background-color: ${colors.darkBlue};
  color: ${colors.white};
  padding: 12px 20px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  gap: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  z-index: 9999;
  font-size: 14px;
`;

const RefreshButton = styled.button`
  background-color: ${colors.blue};
  color: ${colors.white};
  border: none;
  padding: 6px 16px;
  border-radius: 8px;
  font-size: 14px;
  font-family: inherit;
  cursor: pointer;
  white-space: nowrap;

  &:active {
    opacity: 0.8;
  }
`;

function ReloadPrompt() {
  const {
    needRefresh: [needRefresh],
    updateServiceWorker,
  } = useRegisterSW();

  if (!needRefresh) return null;

  return (
    <Toast>
      <span>גרסה חדשה זמינה</span>
      <RefreshButton onClick={() => updateServiceWorker(true)}>
        רענן
      </RefreshButton>
    </Toast>
  );
}

export default ReloadPrompt;
